const en = {
    deliveryApp: 'DeliveryApp',
    name: 'Name',
    userName: 'User name',
    lastName: 'Last name',
    telephoneNr:'Telephone number',
    finish: 'Finish',
    finished: 'Finished',
    delete: 'Delete',
    bockPickUp: 'Bock pick up',
    bockBarcodeError: 'Barcode length is wrong !',
    bockCode: 'Bock code',
    bock: 'Bock',
    street: 'Street',
    zipCodePlace: 'Postcode/place',
    number: 'Number',
    bockNumber: 'Bock number',
    deliveryDate: 'Delivery date',
    deliveryTime: 'Delivery time',
    delivery: 'Delivery',
    scannedItems: 'Scanned items',
    bockDelete: 'Delete bock',
    bockDeleteMessage: 'Are you sure ?',
    yes: 'Yes',
    no: 'No',
    orderFinish: 'Finish order',
    orderNumber: 'Order number',
    bockList: 'Bock list',
    emptyList: 'List is empty',
    onTheTruck: 'On the truck',
    atTheCustomer: 'At the customer',
    loadingPlace: 'Loading place',
    loadingStatus: 'Loading status',  
    position: 'Position',  
    positions: 'Positions',
    positionNotFound: 'No positions found for this order',
    commission: 'Commission',
    settings: 'Settings',
    settingsMessage: 'Info: You need an Internet connection to get the settings.',
    customer: 'Customer',
    customerSpecifics: 'Customer specifics',
    driverNotes: 'Driver notes',
    warehouseAddress: 'Warehouse address',
    assemblers: 'Assemblers',
    noAssemblers: 'Assemblers not found',
    sync: 'Sync',
    syncProgress: 'Sync in progress',
    backup: 'Backup',
    sign: 'Sign',    
    customerSignature: 'Customer signature',
    driverSignature: 'Driver signature',
    signDocument: 'Sign document',
    signedDocument: 'Document signed',
    saveDocument: 'Save document',
    saveDocumentForAll: `Save documents for all today's orders from this company`,
    piece: 'Piece',
    width: 'Width',
    height: 'Height',
    comment: 'Comment',
    partially: 'Partially',
    synchronize: 'Synchronize',
    dbLoading:'Database loading',
    stop: 'Stop',
    deletePhoto: 'Delete photo ?',
    cancel: 'Cancel',
    confirm: 'Confirm',
    confirmAuftragMessage0: `All positions are checked but the order status is 'Partial', are you sure you want to continue?`,
    confirmAuftragMessage1: `Not all positions are ticked off but the order status is 'Done', are you sure you want to continue?`,
    confirmAuftragMessage2: 'Are you sure you want to continue ?',
    confirmSelected: 'Confirm selected positions ?',
    company: 'Company',
    none:'None',
    save: 'Save',
    takePhoto: 'Take photo',
    syncFailMessage: 'Synchronization not successful! Please try later!',
    driverList: 'List of drivers',
    punkt1: 'Delivery of goods on time (within 30 minutes ?)',
    punkt2: 'Goods delivery complete ?',
    punkt3: 'Goods delivery visibly damaged?',
    EkName: "Client name",
    start: "Start",
    end: "End",
    clientNotAtHome: "Customer not on site",
    mehrTagesTour: "Multi-day tour",
    tagesTour:"Daily tour",
    signatureEmpty:"Both signatures must be present or customer not on site must be selected",
    cusromerAdress: "Customer address",
    deliveryAdress: "Delivery address"
  };
  
  export default en;